var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576.1 447.9",
    style: {
      enableBackground: "new 0 0 576.1 447.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#253B80;}\n\t.st2{fill:#179BD7;}\n\t.st3{fill:#222D65;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mastercard-brands") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.1,447.9H55.9C25,447.9,0,422.9,0,392v-336C0,25,25,0,55.9,0h464.2c30.9,0,55.9,25,55.9,55.9v336 C576.1,422.9,551,447.9,520.1,447.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221,394.8l6.4-40.3l-14.2-0.3h-67.6l47-297.7c0.3-1.9,1.9-3.3,3.8-3.3h113.9c37.8,0,63.9,7.9,77.6,23.4 c6.4,7.3,10.5,14.9,12.4,23.3c2.1,8.8,2.1,19.3,0.1,32.1l-0.1,0.9v8.2l6.4,3.6c4.9,2.5,9.3,5.8,12.9,9.9c5.5,6.2,9,14.2,10.5,23.5 c1.5,9.7,1,21.1-1.5,34.2c-2.9,15-7.6,28-14,38.7c-5.6,9.6-13.2,17.8-22.2,24.3c-8.5,6-18.5,10.6-29.9,13.5 c-11,2.9-23.6,4.3-37.3,4.3h-8.9c-6.3,0-12.5,2.3-17.3,6.4c-4.8,4.1-8,9.9-9,16.1l-0.7,3.6l-11.2,71.1l-0.5,2.6 c-0.1,0.8-0.4,1.2-0.7,1.5c-0.3,0.3-0.7,0.4-1.2,0.4C275.7,394.8,221,394.8,221,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M412.6,133.8c-0.3,2.2-0.7,4.4-1.2,6.7c-15,77.1-66.4,103.8-132.1,103.8H246c-8,0-14.8,5.8-16,13.7 l-17.1,108.5l-4.8,30.8c-0.7,4.7,2.4,9,7.1,9.8c0.4,0.1,0.9,0.1,1.3,0.1h59.3c7,0,13-5.1,14.1-12l0.6-3l11.2-70.8l0.7-3.9 c1.1-6.9,7.1-12,14.1-12h8.9c57.4,0,102.4-23.3,115.5-90.8c5.5-28.2,2.6-51.7-11.9-68.3C424.3,141.2,418.8,137,412.6,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.9,127.5c-4.8-1.4-9.7-2.5-14.6-3.2c-9.7-1.5-19.6-2.2-29.5-2.1h-89.3c-7,0-13,5.1-14.1,12l-19,120.3 l-0.5,3.5c1.2-7.9,8-13.8,16-13.7h33.4c65.6,0,117.1-26.7,132.1-103.8c0.4-2.3,0.8-4.5,1.2-6.7c-4-2.1-8.1-3.8-12.4-5.2 C399.2,128.2,398.1,127.9,396.9,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.5,134.2c1.1-6.9,7.1-12.1,14.1-12h89.3c10.6,0,20.5,0.7,29.5,2.1c6.1,1,12.1,2.4,18,4.3 c4.4,1.5,8.6,3.2,12.4,5.2c4.5-28.5,0-47.9-15.4-65.5c-17-19.3-47.7-27.6-86.9-27.6H196.4c-8,0-14.9,5.8-16.1,13.8l-47.5,300.8 c-0.8,5.3,2.8,10.4,8.1,11.2c0.5,0.1,1,0.1,1.5,0.1h70.3l17.7-112C230.5,254.5,249.5,134.2,249.5,134.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPp);
export default __webpack_public_path__ + "static/media/PP.00259e61eae419cee105208bd7f090f5.svg";
export { ForwardRef as ReactComponent };